<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title3"><h1 class="title"><strong class="b">Acknowledgements</strong></h1>
<p class="p"><span>I would like to offer my thanks to my wife, Yvonne, who proofread the entire book before submission, helped with the original research, and assisted with suggestions for improvements in many of the chapters.</span></p>
<p class="p-indent"><span>My thanks must also go to the staff of The National Archives at Kew. They always provide a first-class, professional service, and it is always a pleasure to work there.</span></p>
<p class="p-indent"><span>Finally, I must thank Alison Spence, an archivist at the Cornwall Record Office, for her assistance with the research on George Nicholls Simmons, for the chapter on William Henry Clarke.</span></p></a></div><a id="title3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783469529_ack01.vue?6727ab06